import radarDefault from '../../lib/jin/svgchartlib/01_Charts/07_Radar/includes/primitives/Data'

export default radarDefault